module.exports = __webpack_public_path__ + "static/media/circle-download-pdf-white-icon.7ac26f8a.svg";